import React from "react";
import { CommentsTabView } from "./components";

export default function CommentsTab({ disableEditing, informationId = 0, pageStart = 0 }) {
	return <CommentsTabView disableEditing={disableEditing} informationId={informationId} pageStart={pageStart} />;
}
